// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text--digit[data-v-4666b555] {\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.text--label[data-v-4666b555] {\n  font-weight: var(--magic-font-weight-bold, 700);\n}", ""]);
// Exports
module.exports = exports;
